/** Indicador de espera del sistema (`sk-spinner`). Decorativo: lo que se
    espera lo dice el texto de al lado, que es lo que lee el lector. */
export function Spinner() {
  return <span className="sk-spinner" aria-hidden="true" />;
}
